import React from "react";

const InsuranceIndustryLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section className="bg-[#2f2a35] text-white">
                <div className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-10 items-center">
                    <div>
                        <span className="text-sm uppercase text-gray-300">Industries</span>
                        <h1 className="text-4xl md:text-5xl font-bold mt-4">
                            Insurance
                        </h1>
                        <p className="mt-6 text-gray-200 max-w-xl">
                            World-class digital solutions helping insurers innovate faster,
                            modernize operations, and deliver superior customer experiences.
                        </p>
                        <div className="mt-6 text-sm text-orange-400">
                            TechSPR named Leader in Insurance Digital Engineering Services →
                        </div>
                    </div>

                    <div>
                        <img
                            src="/images/industries/insurance/hero.png"
                            alt="Insurance"
                            className="rounded-xl shadow-lg"
                        />
                    </div>
                </div>
            </section>

            {/* ================= INTRO ================= */}
            <section className="py-20">
                <div className="max-w-5xl mx-auto px-6 text-gray-700">
                    <p>
                        Our digital insurance solutions empower providers to meet evolving
                        customer expectations while optimizing operational efficiency in a
                        highly competitive landscape.
                    </p>
                </div>
            </section>

            {/* ================= INSURANCE PROVIDERS ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
                    <div className="md:col-span-2">
                        <h2 className="text-3xl font-bold mb-4">Insurance Providers</h2>
                        <p className="text-gray-700">
                            Rapidly deploy next-generation insurance capabilities using
                            cloud-native platforms, intelligent automation, and AI-driven
                            insights to transform core processes and customer journeys.
                        </p>
                        <button className="mt-6 bg-orange-500 text-white px-6 py-3 rounded-md">
                            Learn more about our industry expertise
                        </button>
                    </div>

                    <div className="bg-[#020617] text-white rounded-xl p-6">
                        <h4 className="font-semibold mb-4">Our Offerings</h4>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>• CX Transformation for Insurance</li>
                            <li>• Cloud & Infrastructure</li>
                            <li>• Intelligent Automation</li>
                            <li>• Data & Analytics</li>
                            <li>• Salesforce for Insurance</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* ================= RE(AI)MAGINING ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(2,6,23,.9), rgba(2,6,23,.9)), url(https://images.unsplash.com/photo-1518770660439-4636190af475)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold">
                        Re(AI)magining™ Banking and Financial Services
                    </h2>
                    <button className="mt-6 bg-white text-black px-6 py-3 rounded-md">
                        Learn more
                    </button>
                </div>
            </section>

            {/* ================= TESTIMONIAL ================= */}
            <section className="bg-[#3a3a3a] text-white py-20">
                <div className="max-w-5xl mx-auto px-6">
                    <p className="italic text-lg">
                        TechSPR helped us rapidly adapt our engineering practices and
                        scale our customer platforms to support exponential growth.”
                    </p>
                    <p className="mt-4 text-sm text-gray-300">
                        — Group Executive, Global Insurance Provider
                    </p>
                </div>
            </section>

            {/* ================= WHY TechSPR ================= */}
            <section className="bg-[#fde7d9] py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
                    {[
                        ["Domain-Centric Product Engineering", "Deep insurance domain expertise combined with digital engineering excellence."],
                        ["AI-First Engineering DNA", "AI-led modernization across underwriting, claims, and customer engagement."],
                        ["Robust Partner Ecosystem", "Strong alliances with hyperscalers and insurance platforms."],
                    ].map(([title, desc]) => (
                        <div key={title}>
                            <h4 className="font-semibold mb-2">{title}</h4>
                            <p className="text-sm text-gray-700">{desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">Client Success</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            {
                                img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85",
                                title: "Insurance leader modernizes claims and underwriting platforms",
                                tag: "Insurance Transformation",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d",
                                title: "Retail brand boosts online sales with AI-powered analytics",
                                tag: "Retail Innovation",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789",
                                title: "Manufacturing company improves efficiency through automation",
                                tag: "Smart Manufacturing",
                            },
                        ].map((item, i) => (
                            <div key={i} className="bg-white text-black rounded-xl overflow-hidden">
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-48 object-cover"
                                />

                                <div className="p-5">
                                    <span className="text-xs text-orange-600">{item.tag}</span>

                                    <p className="mt-2 font-medium">{item.title}</p>

                                    <button className="mt-3 text-orange-600 text-sm hover:underline">
                                        Read the story →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= NEWS ================= */}
            {/* <section className="py-20">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">News & Insights</h2>
                    <div className="grid md:grid-cols-3 gap-6">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="border rounded-xl overflow-hidden">
                                <img
                                    src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d"
                                    alt="Insight"
                                />
                                <div className="p-5">
                                    <span className="text-xs text-orange-600">Blog</span>
                                    <p className="mt-2 font-medium">
                                        Innovating Insurance with AI-Driven Platforms
                                    </p>
                                    <button className="mt-3 text-orange-600 text-sm">
                                        Read the blog →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* ================= SALESFORCE ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(2,6,23,.9), rgba(2,6,23,.9)), url(https://images.unsplash.com/photo-1551434678-e076c223a692)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold">
                        Salesforce for Insurance
                    </h2>
                    <p className="mt-4 max-w-xl text-gray-200">
                        Deliver personalized, data-driven insurance experiences with
                        Salesforce solutions tailored for insurers.
                    </p>
                    <button className="mt-6 bg-white text-black px-6 py-3 rounded-md">
                        Learn more
                    </button>
                </div>
            </section>

            {/* ================= CONTACT ================= */}
            {/* <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">Contact us</h2>
                    <form className="grid md:grid-cols-2 gap-6">
                        <input className="border p-3 rounded" placeholder="First name" />
                        <input className="border p-3 rounded" placeholder="Last name" />
                        <input className="border p-3 rounded" placeholder="Work email" />
                        <input className="border p-3 rounded" placeholder="Company" />
                        <textarea
                            className="border p-3 rounded md:col-span-2"
                            rows="4"
                            placeholder="How can we help?"
                        />
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md">
                            Submit
                        </button>
                    </form>
                </div>
            </section> */}

        </div>
    );
};

export default InsuranceIndustryLayout;
